module.exports = __webpack_public_path__ + "assets/img/root-100-2019-logo-54934fdee6a968e82bf0b71a0197ea3d.png";


//////////////////
// WEBPACK FOOTER
// ./theroot/root-100-2019/src/img/root-100-2019-logo.png
// module id = 217
// module chunks = 0